import React, { useEffect, useMemo, useRef, useState } from "react";
import { HiBars3, HiXMark } from "react-icons/hi2";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  BackButton,
  DeleteButton,
  SaveButton,
  ViewButton,
} from "../../components/common/MainButtonComponent";
import MainButton from "../../components/common/MainButtonComponent";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import SectionSpinner from "../../components/Spinner2";
import { Skeleton } from "@mui/material";
import { routes } from "../../helper/routes";
import "./AssessShared.css";
import "./SetupAssessment.css";
import SetupAssessmentAddQuestionsPage from "./SetupAssessmentAddQuestionsPage";
import {
  getAllQuestionsForAddedQuestionInSetupAndQuestionPool,

  addAssessmentPart,
  addAssessmentSection,
  editAssessmentPart,
  editAssessmentSection,
  //  //updateQuestionSection,

  saveAssessmentQuestions,
  finalizeAssessment as finalizeAssessmentRequest,


  reset_assessment_setup,
  deleteAssessmentSection,
  deleteAssessmentPart,

  remove_assessment_question_from_setup,



} from "../../service/assessSections/assessSectionsService/assessSectionsService";
import { sweetConfirmAlert, sweetSuccessAlert, sweetErrorAlert } from "../../components/common/SweetAlert";
import AssessmentStudentPreviewPage from "./AssessmentStudentPreviewPage";
import SetupAssessmentPartEditPage from "./SetupAssessmentPartEditPage";
import SetupAssessmentSectionEditPage from "./SetupAssessmentSectionEditPage";
import { display } from "@mui/system";
import { set } from "lodash";
import QuestionDetailPage from "./QuestionDetailPage";
import { m } from "framer-motion";
import SetupAssessmentQuestionViewPage from "./SetupAssessmentQuestionViewPage";
import { use } from "react";

const countRequiredQuestions = (questions = []) =>
  (Array.isArray(questions) ? questions : []).reduce(
    (count, row) => count + (row?.answerRequired ? 1 : 0),
    0
  );

const getRequiredQuestionCountMismatch = (parts = []) => {
  if (!Array.isArray(parts)) return null;

  for (let partIndex = 0; partIndex < parts.length; partIndex += 1) {
    const part = parts[partIndex];
    const partName = part?.title || part?.name || `Part ${partIndex + 1}`;

    for (const section of part?.sections || []) {
      if (!section?.allowOptionalQuestions) continue;

      const requiredLimit = Number(section?.requiredQuestionsCount);
      if (!Number.isFinite(requiredLimit) || requiredLimit < 0) continue;

      const requiredCount = countRequiredQuestions(section?.questions || []);
      if (requiredCount !== requiredLimit) {
        return {
          partName,
          requiredLimit,
          requiredCount,
        };
      }
    }
  }

  return null;
};

const normalizeRequiredQuestionFlags = (
  questions = [],
  allowOptionalQuestions = false,
  requiredQuestionsCount = null
) => {
  const normalizedQuestions = Array.isArray(questions) ? questions : [];

  if (!allowOptionalQuestions) {
    return normalizedQuestions.map((row) => ({
      ...row,
      answerRequired: true,
    }));
  }

  const parsedRequiredCount = Number(requiredQuestionsCount);
  if (Number.isFinite(parsedRequiredCount) && parsedRequiredCount >= 0) {
    return normalizedQuestions.map((row, index) => ({
      ...row,
      answerRequired: index < parsedRequiredCount,
    }));
  }

  return normalizedQuestions;
};

const resolveSubQuestionsForRow = (row = {}, questionMap = {}) => {
  const questionSubDetails = Array.isArray(
    questionMap[String(row.questionId)]?.sub_questions_details
  )
    ? questionMap[String(row.questionId)].sub_questions_details
    : [];

  const rowSubQuestions = Array.isArray(row.subQuestions) ? row.subQuestions : [];
  if (!rowSubQuestions.length) {
    return questionSubDetails;
  }

  return rowSubQuestions
    .map((subQuestion) => {
      const subId =
        subQuestion && typeof subQuestion === "object"
          ? subQuestion.question_id ?? subQuestion.questionId ?? subQuestion.id
          : subQuestion;

      const fallback =
        questionSubDetails.find(
          (detail) =>
            String(detail.questionId ?? detail.question_id ?? detail.id) ===
            String(subId)
        ) || null;

      if (subQuestion && typeof subQuestion === "object") {
        return {
          ...(fallback || {}),
          ...subQuestion,
          mark_allocation:
            subQuestion.mark_allocation ??
            subQuestion.sub_mark_allocation ??
            fallback?.mark_allocation ??
            fallback?.sub_mark_allocation ??
            0,
          sub_mark_allocation:
            subQuestion.sub_mark_allocation ??
            subQuestion.mark_allocation ??
            fallback?.sub_mark_allocation ??
            fallback?.mark_allocation ??
            0,
        };
      }

      return fallback;
    })
    .filter(Boolean);
};

const hasPositiveMarksInParts = (parts = [], questionMap = {}) =>
  Array.isArray(parts) &&
  parts.every((part) =>
    (part?.sections || []).every((section) =>
      (section?.questions || []).every((row) => {
        const resolvedSubQuestions = resolveSubQuestionsForRow(row, questionMap);

        if (resolvedSubQuestions.length) {
          return resolvedSubQuestions.every(
            (subQuestion) =>
              Number(subQuestion.mark_allocation ?? subQuestion.sub_mark_allocation ?? 0) > 0
          );
        }

        return Number(row.marks ?? 0) > 0;
      })
    )
  );


//----------------------------------------------------------------
//SetupQuestionRow
//----------------------------------------------------------------

function SetupQuestionRow({
  row,
  question,
  onToggleSelected,
  onMarksChange,
  onSubMarksChange,
  onToggleAnswer,
  onRemove,
  onView,
  dragHandleProps,
  draggableProps,
  innerRef,
  isDragging,
  allow_optional_questions,
  isDisabled = false,
  isRemoving = false,
}) {
  if (!question) return null;

  const hasSubQuestions = Array.isArray(question.sub_questions)
    ? question.sub_questions.length > 0
    : false;
  const isSubQuestion = hasSubQuestions;
  const subQuestionDetails = question.sub_questions_details || [];

  // console.log("Rendering SetupQuestionRow:", { row, question, isSubQuestion, subQuestionDetails });


  return (
    <div
      ref={innerRef}
      {...draggableProps}
      className={`setup-question-row ${isDragging ? "setup-question-row--dragging" : ""
        }`}
    >
      <div className="row g-2 align-items-center">
        <div className="col-12 col-xl setup-question-row__info-col">
          <div className="row g-2 align-items-center">
            <div className="col-12 col-md-auto setup-question-row__handle-col">
              <div className="setup-question-row__handle" {...dragHandleProps}>
                <HiBars3 aria-hidden="true" />
              </div>
            </div>
            <div className="col-12 col-md-2 setup-question-row__type-col">
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <span className="setup-question-row__type">{question.type == "Sub Question" ? "Main Question" : question.type}</span>
                {isSubQuestion && (
                  <span
                    style={{
                      fontSize: "10px",
                      backgroundColor: "#e3f2fd",
                      color: "#1976d2",
                      padding: "2px 6px",
                      borderRadius: "3px",
                      fontWeight: "bold",
                    }}
                    title="Sub Question"
                  >
                    SUB{question.sub_questions.length > 1 ? ` (${question.sub_questions.length})` : ""}
                  </span>
                )}
              </div>
            </div>
            <div className="col-12 col-md-auto setup-question-row__checkbox-col">
              {/* <label className="setup-question-row__checkbox">
                <input
                  type="checkbox"
                  checked={Boolean(row.selected)}
                  onChange={() => onToggleSelected(row.id)}
                  aria-label={`Select ${question.name}`}
                />
              </label> */}
            </div>
            <div className="col-12 col-md-2 setup-question-row__code-col">
              <span className="setup-question-row__code">{question.code}</span>
            </div>
            <div className="col-12 col-md-3 setup-question-row__name-col">
              <h4>{question.name}</h4>
            </div>
            <div className="col-12 col-md-2 setup-question-row__author-col">
              <span className="setup-question-row__author">
                {question.author || "Author"}
              </span>
            </div>
          </div>
        </div>


        {!hasSubQuestions && (
          <div className="col-12 col-xl-auto setup-question-row__marks-col">
            <div className="setup-question-row__marks">
              <input
                type="number"
                min="0"
                value={row.marks}
                disabled={isDisabled}
                onChange={(event) => onMarksChange(row.id, event.target.value)}
                aria-label={`Marks for ${question.name}`}
              />
              <MainButton
                action="save"
                label="Set Marks"
                className="setup-question-row__set-btn"
                disabled={isDisabled}
              />
            </div>
          </div>
        )}

        {allow_optional_questions &&
          <div className="col-12 col-xl-auto setup-question-row__toggle-col">
            <label className="setup-row-toggle">
              <span className={!row.answerRequired ? "active" : ""}>Optional</span>
              <input
                type="checkbox"
                checked={row.answerRequired}
                disabled={isDisabled}
                onChange={() => { onToggleAnswer(row.id); }}
                aria-label={`Toggle answer required for ${question.name}`}
              />
              <span className={row.answerRequired ? "active" : ""}>Required</span>
            </label>
          </div>
        }
        <div className="col-12 col-xl-auto setup-question-row__actions-col">
          <div className="setup-question-row__actions">
            <ViewButton
              label=""
              title="View question"
              onClick={() => onView(question)}
            />
            <DeleteButton
              label=""
              title={isRemoving ? "Removing question..." : "Remove question"}
              disabled={isDisabled}
              loading={isRemoving}
              aria-label={
                isRemoving
                  ? `Removing ${question.name} from assessment`
                  : `Remove ${question.name} from assessment`
              }
              onClick={() => onRemove(row.id)}
            />
          </div>
        </div>
      </div>


      {isSubQuestion && subQuestionDetails.length > 0 && (
        <div className="setup-subquestions">
          {subQuestionDetails.map((subQ) => (
            <div key={subQ.id} className="setup-subquestion">
              <div className="setup-subquestion__header">
                <span className="setup-subquestion__type">{subQ.type}</span>
                <span className="setup-subquestion__code">{subQ.code}</span>
                <span className="setup-subquestion__name">{subQ.name}</span>
              </div>
              <div className="setup-subquestion__content">
                <div
                  className="setup-subquestion__marks"
                  style={{ marginRight: "16px" }}
                >
                  <input
                    type="number"
                    min=""
                    value={subQ.sub_mark_allocation ?? ""}
                    disabled={isDisabled}
                    onChange={(event) =>
                      onSubMarksChange(
                        row.id,
                        String(subQ.question_id ?? subQ.questionId ?? subQ.id),
                        event.target.value
                      )
                    }
                    aria-label={`Marks for ${subQ.name}`}
                  />
                  <MainButton
                    action="save"
                    label="Set Marks"
                    className="setup-question-row__set-btn"
                    disabled={isDisabled}
                  />
                </div>
                <div className="setup-subquestion__actions">
                  <ViewButton
                    label=""
                    title="View sub-question"
                    onClick={() => onView(subQ)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
}

//----------------------------------------------------------------
//  SetupSectionCard 
//----------------------------------------------------------------

function SetupSectionCard({
  partId,
  section,
  rows,
  questionMap,
  onToggleSelected,
  onMarksChange,
  onSubMarksChange,
  onToggleAnswer,
  onRemoveQuestion,
  onEditSection,
  onDeleteSection,
  onViewQuestion,
  isDisabled = false,
  removingQuestionIds = [],
}) {
  return (
    <div className="setup-section-card">
      <div className="setup-section-card__header">
        <div>
          <span className="setup-section-card__eyebrow">Section</span>
          <h3>{section.title}</h3>
          {section.allowInstructions && section.instructions && (
            <p>{section.instructions}</p>
          )}
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <MainButton
            action="delete"
            icon="delete"
            label=""
            tone="danger"
            title="Delete section"
            disabled={isDisabled}
            onClick={() => onDeleteSection(section.id)}
          />
          <MainButton
            action="edit"
            icon="edit"
            label=""
            tone="neutral"
            title="Edit section"
            disabled={isDisabled}
            onClick={() => onEditSection(section)}
          />
        </div>
      </div>

      <div className="setup-section-card__body">
        <Droppable droppableId={`${partId}::${section.id}`}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={`setup-section-card__dropzone ${snapshot.isDraggingOver
                  ? "setup-section-card__dropzone--over"
                  : ""
                }`}
            >
              {rows.length > 0 ? (
                rows.map((row, index) => (
                  <Draggable
                    draggableId={row.id}
                    index={index}
                    key={row.id}
                    isDragDisabled={
                      isDisabled ||
                      removingQuestionIds.includes(String(row.questionId))
                    }
                  >
                    {(dragProvided, dragSnapshot) => {
                      const requiredLimit =
                        section.allowOptionalQuestions ??
                          section.allow_optional_questions
                          ? section.requiredQuestionsCount ?? null
                          : null;

                      const currentRequiredCount = (
                        section.questions || []
                      ).filter((r) => r.answerRequired).length;

                      const rowCurrentlyRequired = Boolean(
                        row.answerRequired
                      );

                      const handleToggleAnswer = (rowId) => {
                        if (isDisabled) return;

                        if (
                          requiredLimit !== null &&
                          !rowCurrentlyRequired &&
                          currentRequiredCount >= Number(requiredLimit)
                        ) {
                          sweetSuccessAlert(
                            "Limit reached",
                            `You can only mark ${requiredLimit} question(s) as required in this section.`,
                            "warning"
                          );
                          return;
                        }

                        onToggleAnswer(partId, section.id, rowId);
                      };

                      return (
                        <SetupQuestionRow
                          row={row}
                          question={questionMap[row.questionId]}
                          onToggleSelected={(rowId) =>
                            onToggleSelected(partId, section.id, rowId)
                          }
                          onMarksChange={(rowId, value) =>
                            onMarksChange(
                              partId,
                              section.id,
                              rowId,
                              value
                            )
                          }
                          onSubMarksChange={(
                            rowId,
                            subQuestionId,
                            value
                          ) =>
                            onSubMarksChange(
                              partId,
                              section.id,
                              rowId,
                              subQuestionId,
                              value
                            )
                          }
                          onToggleAnswer={handleToggleAnswer}
                          onRemove={(rowId) =>
                            onRemoveQuestion(
                              partId,
                              section.id,
                              rowId
                            )
                          }
                          onView={onViewQuestion}
                          dragHandleProps={
                            dragProvided.dragHandleProps
                          }
                          draggableProps={
                            dragProvided.draggableProps
                          }
                          innerRef={dragProvided.innerRef}
                          isDragging={dragSnapshot.isDragging}
                          allow_optional_questions={
                            section.allowOptionalQuestions ??
                            section.allow_optional_questions
                          }
                          isDisabled={isDisabled}
                          isRemoving={removingQuestionIds.includes(
                            String(row.questionId)
                          )}
                        />
                      );
                    }}
                  </Draggable>
                ))
              ) : (
                <div className="setup-empty-state">
                  Drag questions into this section.
                </div>
              )}

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  );
}

function SetupAssessmentSkeleton() {
  return (
    <div className="setup-skeleton" aria-hidden="true">
      <div className="setup-skeleton__topbar">
        <Skeleton variant="rounded" width={92} height={34} />
        <div style={{ flex: 1 }} />
        <div className="setup-skeleton__top-actions">
          <Skeleton variant="rounded" width={128} height={34} />
          <Skeleton variant="rounded" width={88} height={34} />
          <Skeleton variant="rounded" width={116} height={34} />
          <Skeleton variant="rounded" width={86} height={34} />
          <Skeleton variant="rounded" width={86} height={34} />
        </div>
      </div>

      <div className="setup-skeleton__summary">
        <div className="setup-skeleton__summary-left">
          <Skeleton variant="rounded" width={140} height={34} />
          <Skeleton variant="rounded" width={210} height={34} />
        </div>

        <div className="setup-skeleton__summary-center">
          <Skeleton variant="rounded" width={430} height={56} />
        </div>

        <div className="setup-skeleton__summary-right">
          <Skeleton variant="rounded" width={150} height={34} />
        </div>
      </div>

      <div className="setup-skeleton__content">
        <div className="setup-skeleton__part">
          <div className="setup-skeleton__part-header">
            <div className="setup-skeleton__part-title-block">
              <Skeleton variant="text" width={70} height={18} />
              <Skeleton variant="text" width={180} height={28} />
              <Skeleton variant="text" width="86%" height={18} />
            </div>
            <div className="setup-skeleton__button-group">
              <Skeleton variant="rounded" width={34} height={34} />
              <Skeleton variant="rounded" width={34} height={34} />
            </div>
          </div>

          <div className="setup-skeleton__section">
            <div className="setup-skeleton__section-header">
              <div className="setup-skeleton__section-title-block">
                <Skeleton variant="text" width={66} height={18} />
                <Skeleton variant="text" width={240} height={24} />
                <Skeleton variant="text" width="92%" height={16} />
              </div>
              <div className="setup-skeleton__button-group">
                <Skeleton variant="rounded" width={34} height={34} />
                <Skeleton variant="rounded" width={34} height={34} />
              </div>
            </div>

            {Array.from({ length: 2 }).map((_, rowIndex) => (
              <div className="setup-skeleton__row" key={rowIndex}>
                <div className="setup-skeleton__row-left">
                  <Skeleton variant="rounded" width={34} height={34} />
                  <div className="setup-skeleton__row-lines">
                    <Skeleton variant="text" width={120} height={18} />
                    <Skeleton variant="text" width={180} height={20} />
                  </div>
                </div>
                <div className="setup-skeleton__row-right">
                  <Skeleton variant="rounded" width={86} height={38} />
                  <Skeleton variant="rounded" width={34} height={34} />
                  <Skeleton variant="rounded" width={34} height={34} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="setup-skeleton__add-cta setup-skeleton__add-cta--section">
          <Skeleton variant="text" width={112} height={24} />
          <Skeleton variant="circular" width={46} height={46} />
          <Skeleton variant="text" width={160} height={18} />
        </div>

        <div className="setup-skeleton__add-cta setup-skeleton__add-cta--part">
          <Skeleton variant="text" width={92} height={24} />
          <Skeleton variant="circular" width={46} height={46} />
          <Skeleton variant="text" width={150} height={18} />
        </div>
      </div>
    </div>
  );
}

//  SetupAssessmentPage 

export default function SetupAssessmentPage({
  assessment,
  metaDataOptions,
  setOpenSetup,
}) {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  //----------------------------------------------------------------
  //  State 
  //----------------------------------------------------------------

  const [setupQuestionBank, setSetupQuestionBank] = useState([]);
  const [assessmentDetails, setAssessmentDetails] = useState({});

  const [parts, setParts] = useState([]);
  const [setAllMarksValue, setSetAllMarksValue] = useState("");

  const [searchTerm, setSearchTerm] = useState("");






  const [selectedPartId, setSelectedPartId] = useState("");
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [selectedQuestionIds, setSelectedQuestionIds] = useState([]);

  const [isUpdateDrawerOpen, setIsUpdateDrawerOpen] = useState(false);
  const [openAddQuestion, setOpenAddQuestion] = useState(false);
  const [partEditOpen, setPartEditOpen] = useState(null);
  const [sectionEditOpen, setSectionEditOpen] = useState(null);
  const [studentViewOpen, setStudentViewOpen] = useState(false);
  const [questionViewOpen, setQuestionViewOpen] = useState(null);

  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(true);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isFinalized, setIsFinalized] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isStructureLoading, setIsStructureLoading] = useState(false);
  const [removingQuestionIds, setRemovingQuestionIds] = useState([]);
  const assessmentStateLower = String(assessment?.status ?? "").toLowerCase();
  const isPublishLocked = ["reviewcompleted", "published"].includes(
    assessmentStateLower
  );
  const isEditLocked = isPublishing || isFinalized || isPublishLocked;




  // Stable counters — never reset across renders
  const partCounterRef = useRef(1);
  const sectionCounterRef = useRef(1);
  const rowCounterRef = useRef(1);



  // useEffect(() => {
  //   console.log("setupQuestionBank update:", { setupQuestionBank });
  //    console.log("assessmentDetails update:", {  assessmentDetails });
  //     console.log(" parts update:", { parts });
  // }, [setupQuestionBank, assessmentDetails, parts]);

  useEffect(() => {
    setIsFinalized(
      String(
        assessment?.status || ""
      ).toLowerCase() === "ready"
    );
  }, [assessment?.status]);
  //----------------------------------------------------------------
  //  Question / Data Mapping 
  //----------------------------------------------------------------

  const normalizeSubQuestion = (subQuestion) => {
    if (!subQuestion) return null;
    return {
      id: String(subQuestion.question_id ?? subQuestion.id),
      questionId: Number(subQuestion.question_id ?? subQuestion.id),
      code: subQuestion.code || `QUSTN${subQuestion.question_id ?? subQuestion.id}`,
      name: subQuestion.name || `Question ${subQuestion.question_id ?? subQuestion.id}`,
      title: subQuestion.title || "",
      createdAt: subQuestion.created_at || subQuestion.createdAt || "N/A",
      owner: subQuestion.category_id ? `Category ${subQuestion.category_id}` : subQuestion.owner || "N/A",
      type: subQuestion.question_type_name || subQuestion.type || "N/A",
      status: subQuestion.is_subquestion ? "Sub Question" : subQuestion.status || "N/A",
      // author: subQuestion.author || subQuestion.added_by || subQuestion.created_by || "Author",
      author: `${subQuestion.first_name ?? ""} ${subQuestion.last_name ?? ""}`.trim(),
      examCategory: subQuestion.examCategory || subQuestion.category_name || subQuestion.category_id || "N/A",
      source: subQuestion.source || subQuestion.source_name || subQuestion.source_id || "N/A",
      createdBy: subQuestion.createdBy || subQuestion.created_by || "N/A",
      year: subQuestion.year || subQuestion.year_name || subQuestion.year_id || "N/A",
      difficulty: subQuestion.difficulty || subQuestion.difficulty_name || "N/A",
      grade: subQuestion.grade || subQuestion.grade_name || "N/A",
      language: subQuestion.language || subQuestion.language_name || "N/A",
      subject: subQuestion.subject || subQuestion.subject_name || "N/A",
      term: subQuestion.term || subQuestion.term_name || "N/A",
      chapter: subQuestion.chapter || subQuestion.chapter_name || "N/A",
      answer_type_id: subQuestion.answer_type_id ?? null,
      content: subQuestion.content || "",
      answer: subQuestion.answer || "",
      is_subquestion: subQuestion.is_subquestion || false,
      sub_questions: [],
      sub_questions_details: [],
      raw: subQuestion,
      sub_mark_allocation: subQuestion.sub_mark_allocation !== undefined ? subQuestion.sub_mark_allocation : 0
    };
  };

  const mapPoolQuestionToSetupQuestion = (question) => ({
    ...question,
    id: String(question.question_id ?? question.id),
    questionId: Number(question.question_id ?? question.id),
    code: question.code || `QUSTN${question.question_id ?? question.id}`,
    name:
      question.title ||
      question.name ||
      `Question ${question.question_id ?? question.id}`,
    title: question.title || "",
    createdAt: question.created_at || question.createdAt || "N/A",
    questions: Array.isArray(question.sub_questions)
      ? question.sub_questions.length
      : typeof question.sub_questions === "string" && question.sub_questions
        ? question.sub_questions.split(",").filter(Boolean).length
        : Number(question.questions ?? 0),
    owner: question.category_id
      ? `Category ${question.category_id}`
      : question.owner || "N/A",
    type: question.question_type_name || question.type || "N/A",
    status: question.is_subquestion ? "Sub Question" : question.status || "N/A",
    author: `${question.first_name ?? ""} ${question.last_name ?? ""}`.trim(),
    examCategory:
      question.examCategory ||
      question.category_name ||
      question.category_id ||
      "N/A",
    source: question.source || question.source_name || question.source_id || "N/A",
    createdBy: question.createdBy || question.created_by || "N/A",
    year: question.year || question.year_name || question.year_id || "N/A",
    difficulty: question.difficulty || question.difficulty_name || "N/A",
    grade: question.grade || question.grade_name || "N/A",
    language: question.language || question.language_name || "N/A",
    subject: question.subject || question.subject_name || "N/A",
    term: question.term || question.term_name || "N/A",
    chapter: question.chapter || question.chapter_name || "N/A",
    answer_type_id: question.answer_type_id ?? null,
    content: question.content || "",
    answer: question.answer || "",
    is_passage: question.is_passage ?? false,
    passage_id: question.passage_id ?? null,
    passage_content: question.passage_content ?? "",
    is_subquestion: question.is_subquestion || false,
    sub_questions: Array.isArray(question.sub_questions)
      ? question.sub_questions
      : typeof question.sub_questions === "string" && question.sub_questions
        ? question.sub_questions.split(",").map((item) => item.trim()).filter(Boolean)
        : [],
    sub_questions_details: Array.isArray(question.sub_questions_details)
      ? question.sub_questions_details.map(normalizeSubQuestion).filter(Boolean)
      : [],
    raw: question,
  });

  const mapAssessmentDetailsToPartsStructure = (details, normalizedQuestions) => {
    if (!details?.parts || !Array.isArray(details.parts)) return [];

    const questionMapByQuestionId = Object.fromEntries(
      normalizedQuestions.map((q) => [String(q.questionId), q])
    );

    return details.parts.map((apiPart, partIndex) => {
      const notation = details?.notation_value?.find(
        (n) => Number(n.part_id) === Number(apiPart.part_id)
      );
      const partName = notation?.name
        ? String(notation.name)
        : apiPart.part_title;

      return {
        id: `part-${partCounterRef.current++}`,
        assessmentPartId: apiPart.assessment_part_id ?? null,
        partId: apiPart.part_id ?? null,
        displayOrder: apiPart.display_order ?? partIndex + 1,
        name: partName,
        title: apiPart.part_title || `Part ${partName}`,
        notationId: notation?.notation_id ?? null,
        allowInstructions: apiPart.allow_instruction ?? false,
        instructions: apiPart.part_instruction ?? "",
        noOfSections: apiPart.no_of_sections ?? null,
        sections: (apiPart.sections || []).map((apiSection, sectionIndex) => ({
          id: `section-${sectionCounterRef.current++}`,
          assessmentPartId: apiSection.assessment_part_id ?? null,
          assessmentSectionId: apiSection.part_section_id ?? null,
          title: apiSection.section_title || `Section ${sectionIndex + 1}`,
          notationId: apiSection.notation_id ?? null,
          allowInstructions: apiSection.allow_instruction ?? false,
          allowOptionalQuestions: apiSection.allow_optional_questions ?? false,
          questionsToAnswerCount: apiSection.no_of_questions_to_answer ?? null,
          requiredQuestionsCount: apiSection.no_of_required_questions ?? null,
          questionsCount: apiSection.no_of_questions ?? null,
          instructions: apiSection.section_instruction ?? "",
          displayOrder: apiSection.display_order ?? null,
          questions: (apiSection.questions || []).map((apiQuestion) => ({
            id: `setup-row-${rowCounterRef.current++}`,
            questionId: Number(apiQuestion.question_id),
            assessmentQuestionId: apiQuestion.assessment_question_id ?? null,
            marks: Number(apiQuestion.mark_allocation ?? 0),
            selected: false,
            answerRequired: !Boolean(apiQuestion.is_optional),
            is_have_subquestion: apiQuestion.is_subquestion ?? false,
            subQuestions: Array.isArray(apiQuestion.sub_questions)
              ? apiQuestion.sub_questions
              : [],
            allowOptionalQuestions:
              apiSection.allow_optional_questions ?? false,
            requiredQuestionsCount:
              apiSection.no_of_required_questions ?? null,
          })),
        })),
      };
    });
  };

  //----------------------------------------------------------------
  //  Data Fetching
  //----------------------------------------------------------------

  const loadSetupData = async () => {
    try {
      setIsInitialLoading(true);
      const response =
        await getAllQuestionsForAddedQuestionInSetupAndQuestionPool(
          assessment?.assessment_id ?? assessment?.id
        );
      const poolQuestions = response?.data?.questions_in_pool ?? response?.questions_in_pool ?? [];
      console.log("setup poolQuestions:", poolQuestions);
      console.log("first setup question:", poolQuestions[0]);
      const normalizedQuestions = poolQuestions.map(mapPoolQuestionToSetupQuestion);

      const details = response?.data?.assessmentDetails ?? response?.assessmentDetails ?? {};

      setAssessmentDetails(details);
      setSetupQuestionBank(normalizedQuestions);
      setSetAllMarksValue("");

      const mappedParts = mapAssessmentDetailsToPartsStructure(details, normalizedQuestions);
      setParts(mappedParts);

    } catch (error) {
      console.error("Error fetching questions for setup and pool:", error);
      throw error;
    } finally {
      setIsInitialLoading(false);
    }
  };

  useEffect(() => {
    loadSetupData();
  }, [assessment]);

  //----------------------------------------------------------------
  // Save Changes — calls API #4 (saveUpdates)
  //----------------------------------------------------------------

  const saveChanges = async () => {

    const requiredQuestionMismatch = getRequiredQuestionCountMismatch(parts);
    if (requiredQuestionMismatch) {
      sweetErrorAlert(
        "Required Questions",
        `${requiredQuestionMismatch.partName} should have ${requiredQuestionMismatch.requiredLimit} required questions.`,
        "error"
      );
      return;
    }

    //*************//log save action with details************************************************************************
    const assessmentId = assessment?.assessment_id ?? assessment?.id;
    const userRoleId =
      assessmentDetails?.user_role_id ||
      assessment?.user_role_id ||
      assessment?.added_by ||
      "";

    // Build questions array including both main questions and their sub-questions
    const questions = [];
    parts.forEach((part) => {
      part.sections.forEach((section) => {
        section.questions.forEach((row, questionIndex) => {
          const q = questionMap[row.questionId] ?? {};
          const subDetails = Array.isArray(q.sub_questions_details)
            ? q.sub_questions_details
            : [];

          // Main question entry (for questions that may have sub-questions, keep mark 0)
          questions.push({
            question_id: row.questionId,
            assessment_question_id: row.assessmentQuestionId ?? null,
            added_by: userRoleId,

            part_id: part.assessmentPartId,
            part_name: part.title || part.name || "",
            part_instruction: part.instructions ?? "",
            allow_part_instruction: part.allowInstructions ?? false,
            section_id: section.assessmentSectionId,
            section_title: section.title || "",
            section_name: section.title || "",
            section_instruction: section.instructions ?? "",
            allow_section_instruction: section.allowInstructions ?? false,

            question_number: questionIndex + 1,
            mark_allocation: subDetails.length > 0 ? 0 : Number(row.marks ?? 0),
            is_optional: !Boolean(row.answerRequired),

            title: q.name || q.title || "",
            content: q.content || "",
            answer: q.answer || "",
            qtype: q.raw?.qtype ?? null,
            question_type: q.type || "",
            answer_type_id: q.raw?.answer_type_id ?? null,
            is_content_blob: q.raw?.is_content_blob ?? "false",
            is_answer_blob: q.raw?.is_answer_blob ?? "false",
            guidence: q.raw?.guidence || "",
            passage_id: q.raw?.passage_id ?? null,
            passage_content: q.raw?.passage_content ?? "",
            is_passage: q.raw?.is_passage ?? false,
            is_subquestion: q.raw?.is_subquestion ?? null,
            sub_questions: q.raw?.sub_questions ?? null,
            tags: q.raw?.tags ?? "",
            subject_id: q.raw?.subject_id ?? null,
            grade_id: q.raw?.grade_id ?? null,
            language_id: q.raw?.language_id ?? null,
            chapter_id: q.raw?.chapter_id ?? null,
            term_id: q.raw?.term_id ?? null,
            year_id: q.raw?.year_id ?? null,
            source_id: q.raw?.source_id ?? null,
            category_id: q.raw?.category_id ?? null,
            difficulty_id: q.raw?.difficulty_id ?? null,
            author_id: q.raw?.author_id ?? null,
            question_category: q.raw?.question_category ?? null,
            question_difficulty: q.raw?.question_difficulty ?? null,
            created_by: q.raw?.created_by ?? "",
            created_at: q.raw?.created_at ?? "",
            first_name: q.raw?.first_name ?? "",
            last_name: q.raw?.last_name ?? "",
          });

          // If there are sub-question details, push each as separate entries
          if (subDetails.length > 0) {
            subDetails.forEach((subQ) => {
              // try to find mark allocation from row.subQuestions if present
              const subFromRow = (Array.isArray(row.subQuestions)
                ? row.subQuestions.find(
                  (s) =>
                    String(s.question_id ?? s.questionId ?? s.id) ===
                    String(subQ.questionId)
                )
                : null) || {};

              const subMark =
                subQ.sub_mark_allocation ??
                subQ.raw?.sub_mark_allocation ??
                subFromRow.mark_allocation ??
                0;

              questions.push({
                question_id: Number(subQ.questionId ?? subQ.id),
                assessment_question_id: subQ.assessment_question_id ?? null,
                added_by: userRoleId,

                part_id: part.assessmentPartId,
                part_name: part.title || part.name || "",
                part_instruction: part.instructions ?? "",
                allow_part_instruction: part.allowInstructions ?? false,
                section_id: section.assessmentSectionId,
                section_title: section.title || "",
                section_name: section.title || "",
                section_instruction: section.instructions ?? "",
                allow_section_instruction: section.allowInstructions ?? false,

                // sub-questions inherit the parent's question_number
                question_number: questionIndex + 1,
                mark_allocation: Number(subMark),
                is_optional: !Boolean(row.answerRequired),

                title: subQ.name || subQ.title || "",
                content: subQ.content || subQ.raw?.content || "",
                answer: subQ.answer || subQ.raw?.answer || "",
                qtype: subQ.raw?.qtype ?? null,
                question_type: subQ.type || subQ.raw?.type || "",
                answer_type_id: subQ.raw?.answer_type_id ?? null,
                is_content_blob: subQ.raw?.is_content_blob ?? "false",
                is_answer_blob: subQ.raw?.is_answer_blob ?? "false",
                guidence: subQ.raw?.guidence || "",
                passage_id: subQ.raw?.passage_id ?? null,
                passage_content: subQ.raw?.passage_content ?? "",
                is_passage: subQ.raw?.is_passage ?? false,
                is_subquestion: true,
                parent_question_id: row.questionId,
                tags: subQ.raw?.tags ?? "",
                subject_id: subQ.raw?.subject_id ?? null,
                grade_id: subQ.raw?.grade_id ?? null,
                language_id: subQ.raw?.language_id ?? null,
                chapter_id: subQ.raw?.chapter_id ?? null,
                term_id: subQ.raw?.term_id ?? null,
                year_id: subQ.raw?.year_id ?? null,
                source_id: subQ.raw?.source_id ?? null,
                category_id: subQ.raw?.category_id ?? null,
                difficulty_id: subQ.raw?.difficulty_id ?? null,
                author_id: subQ.raw?.author_id ?? null,
                question_category: subQ.raw?.question_category ?? null,
                question_difficulty: subQ.raw?.question_difficulty ?? null,
                created_by: subQ.raw?.created_by ?? "",
                created_at: subQ.raw?.created_at ?? "",
                first_name: subQ.raw?.first_name ?? "",
                last_name: subQ.raw?.last_name ?? "",
              });
            });
          }
        });
      });
    });



    const payloadParts = parts.map((part, partIndex) => ({
      assessment_part_id: part.assessmentPartId,
      // part_id: part.notationId,
      part_id: part.partId,
      part_title: part.title || part.name || "",
      part_instruction: part.instructions ?? "",
      allow_instruction: part.allowInstructions ?? false,
      no_of_sections: part.sections.length,
      display_order: part.displayOrder ?? partIndex + 1,
      sections: part.sections.map((section) => ({
        assessment_section_id: section.assessmentSectionId,
        section_id: section.notationId,
        section_title: section.title || "",
        notation_id: section.notationId,
        display_order: section.displayOrder ?? null,
        section_instruction: section.instructions ?? "",
        allow_instruction: section.allowInstructions ?? false,
        allow_optional_questions: section.allowOptionalQuestions ?? false,
        no_of_questions_to_answer: section.questionsToAnswerCount ?? null,
        no_of_required_questions: section.allowOptionalQuestions
          ? countRequiredQuestions(section.questions)
          : null,
        no_of_questions: section.questions?.length ?? 0,
      })),
    }));

    const payload = {
      assessment_id: assessmentId,
      allQuestions: questions,
      user_role_id: userRoleId,
      parts: payloadParts,


    };
    //*************//log save action with details***********************************************************************


    try {
      setIsSaving(true);

      const response = await saveAssessmentQuestions(payload);

      setIsSaved(true);
    } catch (error) {
      console.error("Failed to save assessment setup:", error);
    } finally {
      setIsSaving(false);
    }
  };

  //----------------------------------------------------------------
  //  Handle questions added from the "Add Questions" sub-page
  //----------------------------------------------------------------

  const handleAddedQuestions = async () => {
    try {
      await loadSetupData();
    } catch (error) {
      console.error(
        "Failed to refresh setup questions after adding:",
        error
      );

      sweetErrorAlert(
        "Questions added, but the latest details could not be refreshed.",
        "Please try reopening the assessment setup."
      );
    }
  };
  // const handleAddedQuestions = (selectedQuestionsDetails = []) => {

  //   if (
  //     !Array.isArray(selectedQuestionsDetails) ||
  //     !selectedQuestionsDetails.length
  //   )
  //     return;

  //   const questionsToAppend = selectedQuestionsDetails.map(
  //     mapPoolQuestionToSetupQuestion
  //   );

  //   const appendUnique = (currentList) => {
  //     const existingIds = new Set(currentList.map((q) => String(q.id)));
  //     const next = [...currentList];
  //     questionsToAppend.forEach((q) => {
  //       if (!existingIds.has(String(q.id))) {
  //         next.push(q);
  //         existingIds.add(String(q.id));
  //       }
  //     });
  //     return next;
  //   };

  //   setSetupQuestionBank(appendUnique);

  // };
  //----------------------------------------------------------------
  // Part / Section helpers
  //----------------------------------------------------------------

  const createQuestionEntry = (question, seed = 0) => ({
    id: `setup-row-${rowCounterRef.current++}`,
    questionId: question.questionId ?? Number(question.id),
    marks: 0,
    subQuestionMarks: {},
    selected: false,
    answerRequired: seed % 2 === 0,
  });

  const expandQuestionWithSubQuestions = (question, seed = 0) => {
    // Check if question has sub_questions_details
    const hasSubQuestions =
      Array.isArray(question.sub_questions_details) &&
      question.sub_questions_details.length > 0;

    if (hasSubQuestions) {
      // Return an entry for each sub-question
      return question.sub_questions_details.map((subQuestion, index) =>
        createQuestionEntry(subQuestion, seed + index)
      );
    }

    // Otherwise return a single entry for the parent question
    return [createQuestionEntry(question, seed)];
  };

  const createSection = (title, questions = [], seed = 0) => ({
    id: `section-${sectionCounterRef.current++}`,
    assessmentPartId: null,
    assessmentSectionId: null,
    title,
    notationId: null,
    allowInstructions: false,
    allowOptionalQuestions: false,
    instructions: "",
    questions: questions.map((q, index) =>
      createQuestionEntry(q, seed + index)
    ),
  });

  const getPartNotation = (partNumber) => {
    const notationValues = Array.isArray(assessmentDetails?.notation_value)
      ? assessmentDetails.notation_value
      : [];
    return (
      notationValues.find(
        (n) => Number(n.part_id) === Number(partNumber)
      ) ||
      notationValues[partNumber - 1] ||
      null
    );
  };

  const createPart = (partNumber) => {
    const notation = getPartNotation(partNumber);
    const partName = notation?.name
      ? String(notation.name)
      : `Part ${partNumber}`;
    return {
      id: `part-${partCounterRef.current++}`,
      assessmentPartId: null,
      partId: notation?.part_id ?? null,
      name: partName,
      title: notation?.name ? `Part ${partName}` : partName,
      notationId: notation?.notation_id ?? null,
      allowInstructions: false,
      instructions: "",
      noOfSections: null,
      sections: [],
    };
  };
  //----------------------------------------------------------------
  // Add Part — calls API #2, then updates local state 
  //----------------------------------------------------------------

  const maxParts = useMemo(
    () => Number(assessmentDetails?.no_of_parts),
    [assessmentDetails?.no_of_parts]
  );

  const canAddMoreParts = useMemo(
    () => {
      if (!Number.isFinite(maxParts) || maxParts <= 0) return true;
      return parts.length < maxParts;
    },
    [maxParts, parts.length]
  );

  const addPart = async () => {
    if (isEditLocked || !canAddMoreParts) return;

    const nextPartNumber = parts.length + 1;
    const notation = getPartNotation(nextPartNumber);


    const payload = {
      assessment_id: assessment?.assessment_id ?? assessment?.id,
      created_by: assessmentDetails?.created_by || assessment?.created_by || "",
      // part_id: notation?.notation_id ?? nextPartNumber,
      part_id: notation?.part_id ?? null,
      part_title: notation?.name ? `Part ${notation.name}` : `Part ${nextPartNumber}`,
      display_order: nextPartNumber,
      part_instruction: "",
      allow_instruction: false,
      no_of_sections: "1",
    };

    try {
      setIsStructureLoading(true);
      const result = await addAssessmentPart(payload);

      const newAssessmentPartId =
        result?.data?.assessment_part_id ??
        result?.assessment_part_id ??
        null;

      const newPart = createPart(nextPartNumber);
      newPart.assessmentPartId = newAssessmentPartId;
      newPart.partId = notation?.part_id ?? null;
      newPart.notationId = notation?.notation_id ?? null;

      setParts((prev) => [...prev, newPart]);
    } catch (error) {
      console.error("Error adding assessment part:", error);
    } finally {
      setIsStructureLoading(false);
    }
  };
  //----------------------------------------------------------------
  // Add Section — calls API #3, then updates local state 
  //----------------------------------------------------------------

  const addSection = async (partId) => {
    if (isEditLocked) return;

    const targetPart = parts.find((p) => p.id === partId);
    if (!targetPart) return;

    const maxSections = Number(targetPart.noOfSections);
    const hasSectionLimit = Number.isFinite(maxSections) && maxSections > 0;
    if (hasSectionLimit && targetPart.sections.length >= maxSections) {
      sweetSuccessAlert(
        "Limit reached",
        `Maximum ${maxSections} section(s) allowed for this part.`,
        "warning"
      );
      return;
    }

    const nextSectionNumber = targetPart.sections.length + 1;
    const sectionTitle = `${targetPart.title}.${nextSectionNumber}`;

    const payload = {
      assessment_part_id: targetPart.assessmentPartId,
      created_by:
        assessmentDetails?.created_by ||
        assessment?.created_by ||
        "",
      section_title: sectionTitle,
      section_instruction: "",
      display_order: nextSectionNumber,
      allow_instruction: false,
      allow_optional_questions: false,
      notation_id: targetPart.notationId ?? null,
      no_of_questions_to_answer: null,
      no_of_required_questions: null,
    };

    try {
      setIsStructureLoading(true);
      const result = await addAssessmentSection(payload);
      const newSectionId =
        result?.data?.part_section_id ??
        result?.part_section_id ??
        null;

      const newSection = createSection(sectionTitle);
      newSection.assessmentPartId = targetPart.assessmentPartId;
      newSection.assessmentSectionId = newSectionId;

      setParts((currentParts) =>
        currentParts.map((part) => {
          if (part.id !== partId) return part;
          return { ...part, sections: [...part.sections, newSection] };
        })
      );
    } catch (error) {
      console.error("Error adding assessment section:", error);
    } finally {
      setIsStructureLoading(false);
    }
  };
  //----------------------------------------------------------------
  // Delete Part — removes part from local state 
  //----------------------------------------------------------------

  const deletePart = (partId) => {
    if (isEditLocked) return;

    setParts((currentParts) => currentParts.filter((p) => p.id !== partId));

    const part = parts.find((p) => p.id === partId);

    deleteAssessmentPart(assessment?.assessment_id ?? assessment?.id, part?.assessmentPartId)


  };

  const deleteSection = (partId, sectionId) => {
    if (isEditLocked) return;

    setParts((currentParts) =>
      currentParts.map((part) => {
        if (part.id !== partId) return part;
        return {
          ...part,
          sections: part.sections.filter((s) => s.id !== sectionId),
        };
      })
    );

    const section = parts
      .find((p) => p.id === partId)
      ?.sections.find((s) => s.id === sectionId);

    deleteAssessmentSection(assessment?.assessment_id ?? assessment?.id, section?.assessmentSectionId)

  };


  const goToPartEdit = (part) => {
    if (isEditLocked) return;

    const assessmentPart = assessmentDetails?.parts?.find(
      (item) => item.assessment_part_id === part.assessmentPartId
    );

    setPartEditOpen({
      ...part,
      sectionsCount: assessmentPart?.no_of_sections ?? part.sectionsCount ?? 0,
      displayOrder:part.displayOrder ??assessmentPart?.display_order ??1,
      allowInstructions:
        part.allowInstructions ?? assessmentPart?.allow_instruction ?? false,
      instructions:
        (part.allowInstructions ?? assessmentPart?.allow_instruction ?? false)
          ? part.instructions ?? assessmentPart?.part_instruction ?? ""
          : "",
    });
  };
  const handlePartEditDetails = async (updatedPart) => {
    if (!updatedPart?.assessmentPartId) {
      sweetErrorAlert(
        "Unable to update part",
        "The assessment part ID is missing.",
        "error"
      );
      return;
    }

    const payload = {
      title: updatedPart.title,
      displayOrder: Number(updatedPart.displayOrder) || 1,
      sectionsCount: Number(updatedPart.sectionsCount) || 0,
      allowInstructions: Boolean(updatedPart.allowInstructions),
      instructions: updatedPart.allowInstructions
        ? updatedPart.instructions || ""
        : "",
    };
    try {
      setIsStructureLoading(true);

      await editAssessmentPart(
        updatedPart.assessmentPartId,
        payload
      );

      setParts((currentParts) =>
        currentParts.map((part) => {
          if (
            part.id !== updatedPart.id &&
            part.assessmentPartId !== updatedPart.assessmentPartId
          ) {
            return part;
          }

          return {
            ...part,
            title: updatedPart.title,
            name: updatedPart.title,
            displayOrder: Number(updatedPart.displayOrder) || 1,
            sectionsCount: Number(updatedPart.sectionsCount) || 0,
            noOfSections:
              Number(updatedPart.sectionsCount) > 0
                ? Number(updatedPart.sectionsCount)
                : null,
            allowInstructions: Boolean(
              updatedPart.allowInstructions
            ),
            instructions: updatedPart.allowInstructions
              ? updatedPart.instructions || ""
              : "",
          };
        })
      );

      setPartEditOpen(null);

      sweetSuccessAlert(
        "Part updated",
        "The part details were saved permanently.",
        "success"
      );
    } catch (error) {
      console.error("Failed to update assessment part:", error);

      sweetErrorAlert(
        "Unable to update part",
        error?.message || "Please try again.",
        "error"
      );

      throw error;
    } finally {
      setIsStructureLoading(false);
    }
  };

  const goToSectionEdit = (part, section) => {
    if (isEditLocked) return;

    const assessmentPart = assessmentDetails?.parts?.find(
      (item) => item.assessment_part_id === part.assessmentPartId
    );

    setSectionEditOpen({
      part: {
        ...part,
        sectionsCount: part.sections.length,
        displayOrder:
          Number(String(part.id).replace("part-", "")) || 1,
        allowInstructions:
          part.allowInstructions ?? assessmentPart?.allow_instruction ?? false,
        instructions:
          part.instructions ?? assessmentPart?.part_instruction ?? "",
      },
      section: {
        ...section,
        displayOrder: section.displayOrder ?? 1,
        // Question count is derived from the questions currently in the section.
        questionsCount: section.questions?.length ?? 0,
        requiredQuestionsCount: section.requiredQuestionsCount ?? null,
        questionsToAnswerCount: section.questionsToAnswerCount ?? null,
        // Notation fields from state
        notation: section.notation ?? "Alpha",
        notationId: section.notationId ?? null,
        // Instructions and options from current state
        allowInstructions: section.allowInstructions ?? false,
        allowOptionalQuestions: section.allowOptionalQuestions ?? false,
        instructions: section.instructions || "Add instructions for this section here.",
      },
    });
  };

  const handleSectionEditDetails = async (updatedSection) => {
    if (!updatedSection?.assessmentSectionId) {
      sweetErrorAlert(
        "Unable to update section",
        "The assessment section ID is missing.",
        "error"
      );
      return;
    }

    const normalizedRequiredQuestionsCount =
      updatedSection.allowOptionalQuestions &&
        Number(updatedSection.requiredQuestionsCount) >= 0
        ? Number(updatedSection.requiredQuestionsCount)
        : null;

    const payload = {
      assessment_id: Number(
        assessment?.assessment_id ?? assessment?.id
      ),
      assessment_part_id: updatedSection.partAssessmentId,
      section_title: updatedSection.title,
      display_order: Number(updatedSection.displayOrder) || 1,
      // notation_id: updatedSection.notationId ?? null,
      no_of_questions:
        Number(updatedSection.questionsCount) >= 0
          ? Number(updatedSection.questionsCount)
          : null,
      allow_optional_questions: Boolean(
        updatedSection.allowOptionalQuestions
      ),
      no_of_required_questions:
        normalizedRequiredQuestionsCount,
      no_of_questions_to_answer:
        updatedSection.allowOptionalQuestions &&
          Number(updatedSection.questionsToAnswerCount) >= 0
          ? Number(updatedSection.questionsToAnswerCount)
          : null,
      allow_instruction: Boolean(
        updatedSection.allowInstructions
      ),
      section_instruction: updatedSection.allowInstructions
        ? updatedSection.instructions || ""
        : "",
    };

    try {
      setIsStructureLoading(true);

      await editAssessmentSection(
        updatedSection.assessmentSectionId,
        payload
      );

      setParts((currentParts) =>
        currentParts.map((part) => {
          if (
            part.id !== updatedSection.partId &&
            part.assessmentPartId !==
            updatedSection.partAssessmentId
          ) {
            return part;
          }

          return {
            ...part,
            sections: part.sections.map((section) => {
              if (
                section.id !== updatedSection.sectionId &&
                section.assessmentSectionId !==
                updatedSection.assessmentSectionId
              ) {
                return section;
              }

              const updatedQuestions =
                normalizeRequiredQuestionFlags(
                  section.questions,
                  updatedSection.allowOptionalQuestions,
                  normalizedRequiredQuestionsCount
                );

              return {
                ...section,
                title: updatedSection.title,
                displayOrder:
                  Number(updatedSection.displayOrder) || 1,
                // notation: updatedSection.notation,
                // notationId:
                //   updatedSection.notationId ?? null,
                questionsCount:
                  Number(updatedSection.questionsCount) >= 0
                    ? Number(updatedSection.questionsCount)
                    : null,
                allowOptionalQuestions: Boolean(
                  updatedSection.allowOptionalQuestions
                ),
                requiredQuestionsCount:
                  normalizedRequiredQuestionsCount,
                questionsToAnswerCount:
                  updatedSection.allowOptionalQuestions &&
                    Number(
                      updatedSection.questionsToAnswerCount
                    ) >= 0
                    ? Number(
                      updatedSection.questionsToAnswerCount
                    )
                    : null,
                allowInstructions: Boolean(
                  updatedSection.allowInstructions
                ),
                instructions:
                  updatedSection.allowInstructions
                    ? updatedSection.instructions || ""
                    : "",
                questions: updatedQuestions,
              };
            }),
          };
        })
      );

      setSectionEditOpen(null);

      sweetSuccessAlert(
        "Section updated",
        "The section details were saved permanently.",
        "success"
      );
    } catch (error) {
      console.error(
        "Failed to update assessment section:",
        error
      );

      sweetErrorAlert(
        "Unable to update section",
        error?.message || "Please try again.",
        "error"
      );

      throw error;
    } finally {
      setIsStructureLoading(false);
    }
  };

  const goToQuestionView = (question) => {
    setQuestionViewOpen(mapPoolQuestionToSetupQuestion(question));
  };



  const goToAddQuestion = () => {
    setOpenAddQuestion(true);
  };
  //----------------------------------------------------------------
  //  Update Drawer helpers 
  //----------------------------------------------------------------

  const closeUpdateDrawer = () => {
    setIsUpdateDrawerOpen(false);
    setSelectedPartId("");
    setSelectedSectionId("");
    setSelectedQuestionIds([]);
  };

  const assignmentMap = useMemo(() => {
    const map = {};
    parts.forEach((part) => {
      part.sections.forEach((section) => {
        section.questions.forEach((row) => {
          map[String(row.questionId)] = {
            partId: part.id,
            partTitle: part.title,
            sectionId: section.id,
            sectionTitle: section.title,
          };
        });
      });
    });
    return map;
  }, [parts]);

  const drawerRows = useMemo(
    () =>
      setupQuestionBank
        .filter((q) => !assignmentMap[String(q.id)])
        .map((q) => ({
          ...q,
          assignedPart: "N/A",
          assignedSection: "N/A",
        })),
    [assignmentMap, setupQuestionBank]
  );

  // Keep selectedQuestionIds in sync when drawerRows change
  useEffect(() => {
    const visibleIds = new Set(drawerRows.map((r) => String(r.id)));
    setSelectedQuestionIds((current) =>
      current.filter((id) => visibleIds.has(String(id)))
    );
  }, [drawerRows]);

  const questionMap = useMemo(
    () =>
      Object.fromEntries(
        setupQuestionBank.flatMap((q) => [
          [q.id, q],
          [String(q.questionId), q],
        ])
      ),
    [setupQuestionBank]
  );

  const partOptions = useMemo(
    () => parts.map((p) => ({ id: p.id, title: p.title, sections: p.sections })),
    [parts]
  );

  const selectedPart = useMemo(
    () => parts.find((p) => p.id === selectedPartId) || null,
    [parts, selectedPartId]
  );

  const toggleDrawerQuestion = (questionId) => {
    setSelectedQuestionIds((current) =>
      current.includes(questionId)
        ? current.filter((id) => id !== questionId)
        : [...current, questionId]
    );
  };

  const toggleSelectAllDrawerQuestions = () => {
    setSelectedQuestionIds((current) =>
      current.length === drawerRows.length
        ? []
        : drawerRows.map((r) => r.id)
    );
  };
  //----------------------------------------------------------------
  // Restore drawer state after navigation
  //----------------------------------------------------------------

  useEffect(() => {
    const drawerState = location.state?.drawerState;
    if (!drawerState?.reopen) return;

    setIsUpdateDrawerOpen(true);
    setSelectedPartId(drawerState.selectedPartId || "");
    setSelectedSectionId(drawerState.selectedSectionId || "");
    setSelectedQuestionIds(drawerState.selectedQuestionIds || []);

    history.replace({ pathname: location.pathname, state: {} });
  }, [history, location.pathname, location.state]);
  //----------------------------------------------------------------
  //  Restore questions selected from the question picker page
  //----------------------------------------------------------------

  useEffect(() => {
    const pickerState = location.state?.setupQuestionPicker;
    const pickedIds = pickerState?.selectedQuestionIds;
    if (!Array.isArray(pickedIds) || !pickedIds.length) return;

    setParts((currentParts) => {
      const existingQuestionIds = new Set(
        currentParts.flatMap((part) =>
          part.sections.flatMap((section) =>
            section.questions.map((row) => String(row.questionId))
          )
        )
      );

      const questionsToAdd = pickedIds
        .map((qId) =>
          setupQuestionBank.find((q) => String(q.id) === String(qId))
        )
        .filter((q) => q && !existingQuestionIds.has(String(q.id)));

      if (!questionsToAdd.length || !currentParts.length) return currentParts;

      return currentParts.map((part, partIndex) => {
        if (partIndex !== 0 || !part.sections.length) return part;
        return {
          ...part,
          sections: part.sections.map((section, sectionIndex) => {
            if (sectionIndex !== 0) return section;
            return {
              ...section,
              questions: [
                ...section.questions,
                ...questionsToAdd.flatMap((q, idx) =>
                  expandQuestionWithSubQuestions(q, idx)
                ),
              ],
            };
          }),
        };
      });
    });

    history.replace({ pathname: location.pathname, state: {} });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);
  //----------------------------------------------------------------
  // Visible structure (filtered by search) 
  //----------------------------------------------------------------

  const visibleQuestionIds = useMemo(() => {
    const search = searchTerm.trim().toLowerCase();
    return new Set(
      setupQuestionBank
        .filter((q) => {
          if (!search) return true;
          return [q.name, q.code, q.author, q.subject, q.type, q.grade]
            .filter(Boolean)
            .join(" ")
            .toLowerCase()
            .includes(search);
        })
        .map((q) => q.id)
    );
  }, [setupQuestionBank, searchTerm]);

  const visibleStructure = useMemo(
    () =>
      parts.map((part) => ({
        ...part,
        visibleSections: part.sections.map((section) => ({
          ...section,
          visibleQuestions: section.questions.filter((row) =>
            visibleQuestionIds.has(String(row.questionId))
          ),
        })),
      })),
    [parts, visibleQuestionIds]
  );

  const totalMarks = useMemo(
    () =>
      parts.reduce((sum, part) =>
        sum +
        part.sections.reduce((sSum, section) =>
          sSum +
          section.questions.reduce((qSum, row) => {
            const resolvedSubQuestions = resolveSubQuestionsForRow(
              row,
              questionMap
            );

            if (resolvedSubQuestions.length) {
              return (
                qSum +
                resolvedSubQuestions.reduce(
                  (subSum, sq) => subSum + Number(sq.mark_allocation || sq.sub_mark_allocation || 0),
                  0
                )
              );
            }

            return qSum + Number(row.marks || 0);
          }, 0)
          , 0)
        , 0),
    [parts, questionMap]
  );

  const totalQuestions = useMemo(
    () =>
      parts.reduce(
        (sum, part) =>
          sum +
          part.sections.reduce(
            (sectionSum, section) => sectionSum + (section.questions?.length || 0),
            0
          ),
        0
      ),
    [parts]
  );

  const canFinalizeAssessment = useMemo(
    () => isSaved && !isPublishing && !isFinalized && hasPositiveMarksInParts(parts, questionMap),
    [isSaved, isPublishing, isFinalized, parts, questionMap]
  );
  //----------------------------------------------------------------
  // ── Question CRUD helpers 
  //----------------------------------------------------------------

  // Remove a question and its linked sub-questions from the current assessment.
  const removeQuestionFromAssessment = async (questionId) => {
    const normalizedQuestionId = String(questionId);
    if (
      isEditLocked ||
      removingQuestionIds.includes(normalizedQuestionId)
    ) {
      return;
    }

    const question = setupQuestionBank.find(
      (item) => String(item.questionId) === normalizedQuestionId
    );
    const linkedSubQuestionIds = (question?.sub_questions_details || [])
      .filter(
        (subQuestion) =>
          subQuestion?.raw?.sub_assessment_question_id != null ||
          subQuestion?.raw?.assessment_question_id != null
      )
      .map((subQuestion) => subQuestion.questionId);
    const questionIdsToRemove = [
      Number(questionId),
      ...linkedSubQuestionIds.map(Number),
    ].filter(Number.isFinite);

    try {
      await sweetConfirmAlert(
        "Remove question from assessment?",
        "This only removes the link to this assessment. The question will remain in the Question Library.",
        "warning",
        "Remove",
        "Cancel"
      );
    } catch (error) {
      return;
    }

    const assessmentId = assessment?.assessment_id ?? assessment?.id;
    const assessorId =
      assessmentDetails?.user_role_id ||
      assessment?.user_role_id ||
      assessment?.added_by ||
      assessment?.created_by ||
      "";

    try {
      setRemovingQuestionIds((current) => [
        ...current,
        normalizedQuestionId,
      ]);
      await remove_assessment_question_from_setup(
        assessmentId,
        assessorId,
        questionIdsToRemove
      );

      setParts((currentParts) =>
        currentParts.map((part) => ({
          ...part,
          sections: part.sections.map((section) => ({
            ...section,
            questions: section.questions.filter(
              (row) => String(row.questionId) !== normalizedQuestionId
            ),
          })),
        }))
      );
      setSetupQuestionBank((current) =>
        current.filter(
          (item) => String(item.questionId) !== normalizedQuestionId
        )
      );
      setSelectedQuestionIds((current) =>
        current.filter((id) => String(id) !== normalizedQuestionId)
      );
      sweetSuccessAlert(
        "Question removed",
        "The question was removed from this assessment and remains available in the Question Library.",
        "success"
      );
    } catch (error) {
      console.error("Error removing question from assessment:", error);
      sweetErrorAlert(
        "Unable to remove question",
        error?.message || "Please try again.",
        "error"
      );
    } finally {
      setRemovingQuestionIds((current) =>
        current.filter((id) => id !== normalizedQuestionId)
      );
    }
  };

  //----------------------------------------------------------------
  // Remove Question from Section
  // Moves the selected question back to the assessment pool
  //----------------------------------------------------------------
  const removeQuestion = async (partId, sectionId, rowId) => {
    if (isEditLocked) return;

    const row = parts
      .find((p) => p.id === partId)
      ?.sections.find((s) => s.id === sectionId)
      ?.questions.find((r) => r.id === rowId);

    if (row?.questionId == null) return;

    const normalizedQuestionId = String(row.questionId);
    if (removingQuestionIds.includes(normalizedQuestionId)) return;

    const question = setupQuestionBank.find(
      (item) => String(item.questionId) === normalizedQuestionId
    );

    try {
      await sweetConfirmAlert(
        "Remove question from this section?",
        "",
        "warning",
        "Remove",
        "Cancel"
      );
    } catch (error) {
      return;
    }

    const assessmentId = assessment?.assessment_id ?? assessment?.id;
    const assessorId =
      assessmentDetails?.user_role_id ||
      assessment?.user_role_id ||
      assessment?.added_by ||
      assessment?.created_by ||
      "";
    const mainAssessmentQuestionId =
      row.assessmentQuestionId ??
      question?.assessment_question_id ??
      question?.raw?.assessment_question_id ??
      null;

    // Build the payload to remove the question from its current section
    const unassignedQuestions = [
      {
        assessment_question_id: mainAssessmentQuestionId,
        question_id: Number(row.questionId),
        added_by: question?.raw?.added_by ?? assessorId,
        section_id: null,
        mark_allocation: Number(row.marks ?? question?.raw?.mark_allocation ?? 0),
        is_optional: !Boolean(row.answerRequired),
        question_number: question?.raw?.question_number ?? null,
      },
      ...(question?.sub_questions_details || [])
        .filter(
          (subQuestion) =>
            subQuestion?.raw?.sub_assessment_question_id != null ||
            subQuestion?.raw?.assessment_question_id != null
        )
        .map((subQuestion) => ({
          assessment_question_id:
            subQuestion.raw.sub_assessment_question_id ??
            subQuestion.raw.assessment_question_id,
          question_id: Number(subQuestion.questionId),
          added_by: subQuestion.raw.added_by ?? assessorId,
          section_id: null,
          mark_allocation: Number(
            subQuestion.sub_mark_allocation ??
            subQuestion.raw.sub_mark_allocation ??
            0
          ),
          is_optional: !Boolean(row.answerRequired),
          question_number: question?.raw?.question_number ?? null,
        })),
    ];

    try {
      setRemovingQuestionIds((current) => [
        ...current,
        normalizedQuestionId,
      ]);

      await saveAssessmentQuestions({
        assessment_id: Number(assessmentId),
        user_role_id: assessorId,
        parts: [],
        allQuestions: unassignedQuestions,
      });

      setParts((currentParts) =>
        currentParts.map((part) => {
          if (part.id !== partId) return part;
          return {
            ...part,
            sections: part.sections.map((section) => {
              if (section.id !== sectionId) return section;
              return {
                ...section,
                questions: section.questions.filter(
                  (currentRow) => currentRow.id !== rowId
                ),
              };
            }),
          };
        })
      );

      sweetSuccessAlert(
        "Question removed from section",
        "success"
      );
    } catch (error) {
      console.error("Error removing question from section:", error);
      sweetErrorAlert(
        "Unable to remove question from section",
        error?.message || "Please try again.",
        "error"
      );
    } finally {
      setRemovingQuestionIds((current) =>
        current.filter((id) => id !== normalizedQuestionId)
      );
    }
  };

  const applyMarksToAll = () => {
    if (isEditLocked || setAllMarksValue === "") return;
    const numericVal = Number(setAllMarksValue);
    setParts((currentParts) =>
      currentParts.map((part) => ({
        ...part,
        sections: part.sections.map((section) => ({
          ...section,
          questions: section.questions.map((row) => {
            const resolvedSubQuestions = resolveSubQuestionsForRow(
              row,
              questionMap
            );

            // If row has sub-questions, set each sub-question's allocation
            if (resolvedSubQuestions.length) {
              return {
                ...row,
                marks: 0,
                subQuestions: resolvedSubQuestions.map((sq) => ({
                  ...sq,
                  mark_allocation: numericVal,
                  sub_mark_allocation: numericVal,
                })),
              };
            }

            return { ...row, marks: numericVal };
          }),
        })),
      }))
    );
    // Also sync the setup question bank so displayed sub-question details reflect the new allocations
    try {
      setSetupQuestionBank((current) => {
        // Collect questionIds present in parts that have subQuestions
        const questionIdsWithSub = new Set(
          parts.flatMap((p) =>
            p.sections.flatMap((s) =>
              s.questions
                .filter((r) => resolveSubQuestionsForRow(r, questionMap).length > 0)
                .map((r) => String(r.questionId))
            )
          )
        );

        return current.map((q) => {
          if (!questionIdsWithSub.has(String(q.questionId))) return q;
          if (!Array.isArray(q.sub_questions_details) || !q.sub_questions_details.length) return q;

          return {
            ...q,
            sub_questions_details: q.sub_questions_details.map((subQ) => ({
              ...subQ,
              sub_mark_allocation: numericVal,
              raw: { ...(subQ.raw || {}), sub_mark_allocation: numericVal },
            })),
          };
        });
      });
    } catch (e) {
      // non-fatal
      console.error("Failed to sync setupQuestionBank after applyMarksToAll:", e);
    }
    setIsSaved(false);
  };

  const updateQuestionRow = (partId, sectionId, rowId, updater, options = {}) => {
    if (isEditLocked) return;

    setParts((currentParts) =>
      currentParts.map((part) => {
        if (part.id !== partId) return part;
        return {
          ...part,
          sections: part.sections.map((section) => {
            if (section.id !== sectionId) return section;
            const updatedQuestions = section.questions.map((row) =>
              row.id === rowId ? updater(row) : row
            );
            return {
              ...section,
              questions: updatedQuestions,
            };
          }),
        };
      })
    );

    setIsSaved(false);
  };

  const handleSubMarksChange = (partId, sectionId, rowId, subQuestionId, value) => {
    updateQuestionRow(partId, sectionId, rowId, (row) => {
      const updatedSubQuestions = resolveSubQuestionsForRow(row, questionMap).map(
        (subQ) => {
          const subId = subQ?.question_id ?? subQ?.questionId ?? subQ?.id;
          if (String(subId) !== String(subQuestionId)) return subQ;
          return {
            ...subQ,
            mark_allocation: Number(value),
            sub_mark_allocation: Number(value),
          };
        }
      );

      return {
        ...row,
        // subQuestionMarks: {
        //   ...(row.subQuestionMarks || {}),
        //   [String(subQuestionId)]: value,
        // },
        subQuestions: updatedSubQuestions,
      };
    });

    // Also update the corresponding sub-question detail in the setupQuestionBank
    try {
      // find the questionId for this row from current parts
      const part = parts.find((p) => p.id === partId);
      const section = part?.sections.find((s) => s.id === sectionId);
      const row = section?.questions.find((r) => r.id === rowId);
      const questionId = row?.questionId;
      if (!questionId) return;

      setSetupQuestionBank((current) =>
        current.map((q) => {
          if (Number(q.questionId) !== Number(questionId)) return q;
          const updatedSubDetails = Array.isArray(q.sub_questions_details)
            ? q.sub_questions_details.map((subQ) => {
              const subId = subQ?.question_id ?? subQ?.questionId ?? subQ?.id;
              if (String(subId) !== String(subQuestionId)) return subQ;
              return {
                ...subQ,
                sub_mark_allocation: Number(value),
                raw: { ...(subQ.raw || {}), sub_mark_allocation: Number(value) },
              };
            })
            : [];

          return { ...q, sub_questions_details: updatedSubDetails };
        })
      );
    } catch (e) {
      // non-fatal; keep UI responsive
      console.error("Failed to update setupQuestionBank sub-question marks:", e);
    }
  };

  const toggleQuestionSelection = (partId, sectionId, rowId) => {
    updateQuestionRow(partId, sectionId, rowId, (row) => ({
      ...row,
      selected: !row.selected,
    }));
  };
  //----------------------------------------------------------------
  // Drag-and-drop
  //----------------------------------------------------------------

  const reorderVisibleRows = (
    sectionQuestions,
    visibleIds,
    sourceIndex,
    destinationIndex
  ) => {
    const visibleRows = sectionQuestions.filter((row) =>
      visibleIds.has(String(row.questionId))
    );
    const [movedRow] = visibleRows.splice(sourceIndex, 1);
    visibleRows.splice(destinationIndex, 0, movedRow);

    let pointer = 0;
    return sectionQuestions.map((row) => {
      if (!visibleIds.has(String(row.questionId))) return row;
      return visibleRows[pointer++];
    });
  };

  const handleDragEnd = (result) => {
    if (isEditLocked) return;

    const { source, destination, draggableId } = result;
    if (!destination) return;
    if (source.index === destination.index && source.droppableId === destination.droppableId) return;

    const isSourceDrawer = source.droppableId === "drawer";
    const isDestDrawer = destination.droppableId === "drawer";

    const insertAtVisibleIndex = (allRows, visibleIds, visibleIndex, rowsToInsert) => {
      const insertRows = Array.isArray(rowsToInsert) ? rowsToInsert : [rowsToInsert];
      const nextAllRows = [...allRows];
      const visibleRows = nextAllRows.filter((row) =>
        visibleIds.has(String(row.questionId))
      );

      if (!visibleRows.length) {
        nextAllRows.push(...insertRows);
        return nextAllRows;
      }

      if (visibleIndex >= visibleRows.length) {
        const lastVisibleRow = visibleRows[visibleRows.length - 1];
        const lastVisibleIndex = nextAllRows.findIndex((r) => r.id === lastVisibleRow.id);
        nextAllRows.splice(lastVisibleIndex + 1, 0, ...insertRows);
        return nextAllRows;
      }

      const targetVisibleRow = visibleRows[visibleIndex];
      const targetIndex = nextAllRows.findIndex((r) => r.id === targetVisibleRow.id);
      nextAllRows.splice(targetIndex, 0, ...insertRows);
      return nextAllRows;
    };

    // Dragging from drawer into a section
    if (isSourceDrawer && !isDestDrawer) {
      const [partId, sectionId] = destination.droppableId.split("::");
      const poolQuestionId = String(draggableId);
      const poolQuestion = setupQuestionBank.find((q) => String(q.id) === poolQuestionId);
      if (!poolQuestion) return;

      const entriesToInsert = expandQuestionWithSubQuestions(poolQuestion).map((entry) => ({ ...entry }));

      setParts((currentParts) =>
        currentParts.map((part) => {
          if (part.id !== partId) return part;
          return {
            ...part,
            sections: part.sections.map((section) => {
              if (section.id !== sectionId) return section;
              const visibleIds = new Set(
                section.questions
                  .filter((row) => visibleQuestionIds.has(String(row.questionId)))
                  .map((row) => String(row.questionId))
              );
              const nextQuestions = insertAtVisibleIndex(
                section.questions,
                visibleIds,
                destination.index,
                entriesToInsert
              );
              return { ...section, questions: nextQuestions };
            }),
          };
        })
      );

      setIsSaved(false);
      return;
    }

    if (isDestDrawer) return;

    // Dragging between sections or parts
    const [srcPartId, srcSectionId] = source.droppableId.split("::");
    const [destPartId, destSectionId] = destination.droppableId.split("::");

    setParts((currentParts) => {
      const sourcePart = currentParts.find(
        (part) => part.id === srcPartId
      );

      const sourceSection = sourcePart?.sections.find(
        (section) => section.id === srcSectionId
      );

      const destinationPart = currentParts.find(
        (part) => part.id === destPartId
      );

      const destinationSection = destinationPart?.sections.find(
        (section) => section.id === destSectionId
      );

      if (!sourceSection || !destinationSection) {
        return currentParts;
      }

      /*
       * The draggableId belongs to the setup row, not the question ID.
       * Finding by draggableId is safer when search filtering is active.
       */
      const movedRow = sourceSection.questions.find(
        (row) => String(row.id) === String(draggableId)
      );

      if (!movedRow) {
        return currentParts;
      }

      // Reordering inside the same section
      if (
        srcPartId === destPartId &&
        srcSectionId === destSectionId
      ) {
        return currentParts.map((part) => {
          if (part.id !== srcPartId) return part;

          return {
            ...part,
            sections: part.sections.map((section) => {
              if (section.id !== srcSectionId) return section;

              const visibleIds = new Set(
                section.questions
                  .filter((row) =>
                    visibleQuestionIds.has(String(row.questionId))
                  )
                  .map((row) => String(row.questionId))
              );

              return {
                ...section,
                questions: reorderVisibleRows(
                  section.questions,
                  visibleIds,
                  source.index,
                  destination.index
                ),
              };
            }),
          };
        });
      }

      // // Check destination section question limit
      // const maxAllowed = Number(destinationSection.questionsCount);

      // if (
      //   Number.isFinite(maxAllowed) &&
      //   maxAllowed > 0 &&
      //   destinationSection.questions.length >= maxAllowed
      // ) {
      //   sweetErrorAlert(
      //     "Question limit reached",
      //     `This section allows a maximum of ${maxAllowed} questions.`,
      //     "warning"
      //   );

      //   return currentParts;
      // }

      /*
       * Remove the question from the source section first.
       * Then insert it into the destination section at the visible drop index.
       */
      return currentParts.map((part) => ({
        ...part,
        sections: part.sections.map((section) => {
          const isSourceSection =
            part.id === srcPartId && section.id === srcSectionId;

          const isDestinationSection =
            part.id === destPartId && section.id === destSectionId;

          if (isSourceSection) {
            return {
              ...section,
              questions: section.questions.filter(
                (row) => String(row.id) !== String(draggableId)
              ),
            };
          }

          if (isDestinationSection) {
            const visibleIds = new Set(
              section.questions
                .filter((row) =>
                  visibleQuestionIds.has(String(row.questionId))
                )
                .map((row) => String(row.questionId))
            );

            const nextQuestions = insertAtVisibleIndex(
              section.questions,
              visibleIds,
              destination.index,
              movedRow
            );

            return {
              ...section,
              questions: nextQuestions,
            };
          }

          return section;
        }),
      }));
    });

    setIsSaved(false);
  };
  //----------------------------------------------------------------
  //  Apply drawer assignment — calls API #1 (update-section) 
  //----------------------------------------------------------------

  const applyDrawerAssignment = async () => {
    if (isEditLocked || !selectedPartId || !selectedSectionId || !selectedQuestionIds.length)
      return;
    // const targetPart = parts.find((part) => part.id === selectedPartId);
    // const targetSection = targetPart?.sections.find(
    //   (section) => section.id === selectedSectionId
    // );


    // const maxAllowed = Number(targetSection.questionsCount);
    // if (Number.isFinite(maxAllowed) && maxAllowed > 0) {
    //   const currentIds = new Set(
    //     (targetSection.questions || []).map((r) => String(r.questionId))
    //   );

    //   const selectedPoolQuestionIds = selectedQuestionIds
    //     .map((drawerId) =>
    //       setupQuestionBank.find((q) => String(q.id) === String(drawerId))
    //     )
    //     .filter(Boolean)
    //     .map((q) => String(q.questionId));

    //   selectedPoolQuestionIds.forEach((id) => currentIds.add(id));

    //   if (currentIds.size > maxAllowed) {
    //     sweetErrorAlert(
    //       "Question limit exceeded",
    //       `This section allows a maximum of ${targetSection.questionsCount} questions. Please reduce your selection.`,
    //       "warning"
    //     );
    //     return;
    //   }
    // }


    setParts((currentParts) => {

      const selectedEntries = selectedQuestionIds
        .map((drawerId, index) => {
          const existingQuestion = setupQuestionBank.find(
            (question) => String(question.id) === String(drawerId)
          );
          if (!existingQuestion) return null;
          return {
            drawerId: String(drawerId),
            poolQuestionId: String(existingQuestion.questionId),
            existingQuestion,
            seed: index,
          };
        })
        .filter(Boolean);

      const selectedPoolQuestionIdsSet = new Set(
        selectedEntries.map((e) => String(e.poolQuestionId))
      );

      return currentParts.map((part) => ({
        ...part,
        sections: part.sections.map((section) => {
          // Remove any rows that are being moved (compare by pool questionId)
          const cleanedQuestions = section.questions.filter(
            (row) => !selectedPoolQuestionIdsSet.has(String(row.questionId))
          );

          if (part.id === selectedPartId && section.id === selectedSectionId) {
            const existingIds = new Set(
              cleanedQuestions.map((row) => String(row.questionId))
            );

            const appendedRows = selectedEntries
              .filter((entry) => !existingIds.has(String(entry.poolQuestionId)))
              .map((entry) => createQuestionEntry(entry.existingQuestion, entry.seed));

            return {
              ...section,
              questions: [...cleanedQuestions, ...appendedRows],
            };
          }

          return {
            ...section,
            questions: cleanedQuestions,
          };
        }),
      }));
    });

    try {
      const questionIds = selectedQuestionIds
        .map((questionId) =>
          setupQuestionBank.find((question) => String(question.id) === String(questionId))
        )
        .filter(Boolean)
        .map((question) => Number(question.questionId));


      setIsSaved(false);

    } catch (error) {
      console.error("Error saving section question assignment:", error);
      sweetSuccessAlert(
        "Error",
        "Questions were updated locally, but the section assignment could not be saved.",
        "error"
      );
    }

    closeUpdateDrawer();
  };



  //----------------------------------------------------------------
  // Reset Setup — resets local state to initial fetched data
  //----------------------------------------------------------------

  const handleReset = async () => {
    try {
      await sweetConfirmAlert(
        "Reset Changes?",
        "This will discard all unsaved changes and reset to the last saved state.",
        "warning"
      );
    } catch (error) {
      return;
    }

    try {
      closeUpdateDrawer();
      setAssessmentDetails({});
      //setSetupQuestionBank([]);
      setParts([]);
      setSelectedPartId("");
      setSelectedSectionId("");
      setSelectedQuestionIds([]);
      setSetAllMarksValue("");

      await reset_assessment_setup(assessment?.assessment_id ?? assessment?.id);

      await loadSetupData();

    } catch (error) {
      sweetSuccessAlert(
        "Error!",
        "Failed to reset setup. Please try again.",
        "error"
      );
    }
  };

  //----------------------------------------------------------------
  // Student View — navigates to the student view page for this assessment
  //----------------------------------------------------------------

  const studentViewHandler = () => {
    setStudentViewOpen(true);
    //  history.push({
    //             pathname: `${routes.asses_lib}/setup/${id}/student-view`,
    //             state: { parts },
    //           })
  };

  const handleFinalizeAssessment = async () => {
    if (!isSaved || isPublishing || isFinalized) return;

    /*
     * Questions that appear in drawerRows are assessment questions
     * that have not been assigned to any part/section.
     */
    if (drawerRows.length > 0) {
      const questionCodes = drawerRows
        .slice(0, 10)
        .map((question) => question.code)
        .join(", ");

      const remainingCount = Math.max(drawerRows.length - 10, 0);

      sweetErrorAlert(
        "Unassigned Questions",
        `All questions must be assigned to a part and section before finalizing. Unassigned: ${questionCodes}${remainingCount > 0 ? ` and ${remainingCount} more` : ""
        }`,
        "error"
      );

      return;
    }

    const requiredQuestionMismatch =
      getRequiredQuestionCountMismatch(parts);

    if (requiredQuestionMismatch) {
      sweetErrorAlert(
        "Required Questions",
        `${requiredQuestionMismatch.partName} should have ${requiredQuestionMismatch.requiredLimit} required questions.`,
        "error"
      );

      return;
    }

    if (!hasPositiveMarksInParts(parts, questionMap)) {
      sweetErrorAlert(
        "Marks Required",
        "Add positive marks to every question before finalizing the paper.",
        "error"
      );

      return;
    }

    const payload = {
      assessment_id: Number(
        assessment?.assessment_id ?? assessment?.id
      ),
      user_role_id:
        assessmentDetails?.user_role_id ||
        assessment?.user_role_id ||
        assessment?.added_by ||
        assessment?.created_by ||
        "",
      assessment_state: "Ready",
      status_id: 2,
    };

    try {
      setIsPublishing(true);

      const response = await finalizeAssessmentRequest(payload);

      /*
       * APIHandler may return an unsuccessful response instead of throwing.
       * Therefore, success must be checked manually.
       */
      if (response?.success !== true) {
        const errorMessage =
          response?.message?.error ||
          response?.message ||
          "Failed to finalize assessment.";

        sweetErrorAlert(
          "Unable to Finalize",
          errorMessage,
          "error"
        );

        return;
      }

      setIsFinalized(true);

      sweetSuccessAlert(
        "Ready!",
        response?.message?.success ||
        "The assessment is ready to be published.",
        "success"
      );
    } catch (error) {
      console.error("Failed to finalize assessment:", error);

      const errorMessage =
        error?.message?.error ||
        error?.message ||
        "Failed to finalize assessment. Please try again.";

      sweetErrorAlert(
        "Unable to Finalize",
        errorMessage,
        "error"
      );
    } finally {
      setIsPublishing(false);
    }
  };

  const handleMakeEditable = async () => {
    if (isPublishing || !isFinalized) return;

    const payload = {
      assessment_id: Number(assessment?.assessment_id ?? assessment?.id),
      user_role_id:
        assessmentDetails?.user_role_id ||
        assessment?.user_role_id ||
        assessment?.added_by ||
        assessment?.created_by ||
        "",
      assessment_state: "Initial",
      status_id: 1,
    };

    try {
      setIsPublishing(true);
      await finalizeAssessmentRequest(payload);
      setIsFinalized(false);
      sweetSuccessAlert("Editable!", "The assessment is now editable.", "success");
    } catch (error) {
      console.error("Failed to make assessment editable:", error);
      sweetSuccessAlert(
        "Error!",
        "Failed to make assessment editable. Please try again.",
        "error"
      );
    } finally {
      setIsPublishing(false);
    }
  };

  //----------------------------------------------------------------------------------------------------------------------------------------------------

  if (openAddQuestion) {
    return (
      <SetupAssessmentAddQuestionsPage
        metadataOptions={metaDataOptions}
        setOpenAddQuestion={setOpenAddQuestion}
        assessmentId={assessment?.assessment_id ?? assessment?.id}
        addedQuestions={handleAddedQuestions}
      />
    );
  }

  if (studentViewOpen) {
    return (
      <AssessmentStudentPreviewPage
        setOpenStudentView={setStudentViewOpen}
        assessment={assessment}
        parts={parts}
        setupQuestionBank={setupQuestionBank}
        metadataOptions={metaDataOptions}
      />
    );
  }

  if (partEditOpen) {
    return (
      <SetupAssessmentPartEditPage
        assessment={assessment}
        part={partEditOpen}
        setOpenPartEdit={setPartEditOpen}
        editDetails={handlePartEditDetails}
      />
    );
  }

  if (sectionEditOpen) {
    return (
      <SetupAssessmentSectionEditPage
        assessment={assessment}
        part={sectionEditOpen.part}
        section={sectionEditOpen.section}
        setOpenSectionEdit={setSectionEditOpen}
        editDetails={handleSectionEditDetails}
        // notationOptions={metaDataOptions?.notationsOptions || metaDataOptions?.notationOptions || []}
      />
    );
  }

  if (questionViewOpen) {
    return (
      <SetupAssessmentQuestionViewPage
        setOpenQuestionView={setQuestionViewOpen}
        question={questionViewOpen}
      />
    );
  }

  if (isInitialLoading) {
    return (
      <ContentWrapper>
        <section className="assess-section setup-assessment-page">
          <SetupAssessmentSkeleton />
        </section>
      </ContentWrapper>
    );
  }

  return (
    <ContentWrapper>
      <section className="assess-section setup-assessment-page">
        {/* ── Top bar ── */}
        <div className="setup-topbar">
          <BackButton
            label="Back"
            onClick={() => setOpenSetup(false)}
          />
          <div className="setup-topbar__spacer">
            <MainButton
              action="add"
              icon="add"
              label="Add New Question"
              tone="success"
              disabled={isEditLocked}
              onClick={goToAddQuestion}
            />
            <MainButton
              action="refresh"
              icon="refresh"
              label="Reset"
              tone="neutral"
              disabled={isEditLocked}
              onClick={handleReset}
            />
            <MainButton
              action="view"
              icon="view"
              label="Student View"
              tone="primary"
              onClick={studentViewHandler}
            />
            <SaveButton
              label={isSaving ? "Saving..." : isSaved ? "Saved" : "Save Changes"}
              disabled={isSaved || isSaving || isEditLocked}
              onClick={saveChanges}
            />
            <MainButton
              action="publish"
              label={isPublishing ? "Please wait..." : isFinalized ? "Editable Mode" : "Finalize"}
              tone="success"
              disabled={isPublishing || isPublishLocked || (!isSaved && !isFinalized) || (!isFinalized && !canFinalizeAssessment)}
              onClick={isFinalized ? handleMakeEditable : handleFinalizeAssessment}
            />
          </div>
          {!isFinalized && !isPublishLocked && !isPublishing && !canFinalizeAssessment && (
            <div
              style={{
                width: "100%",
                marginTop: "2px",
                paddingLeft: "12px",
                borderLeft: "3px solid #cbd5e1",
                color: "#64748b",
                fontSize: "12px",
                lineHeight: 1.4,
              }}
            >
              Add marks and save changes to enable finalizing.
            </div>
          )}
        </div>

        {/* ── Summary bar ── */}
        <div className="setup-summary">
          <div className="row g-2 align-items-center w-100">
            {/* No of questions */}
            <div className="col-12 col-sm-auto">
              <div className="setup-count">
                No of questions: <strong>{totalQuestions}</strong>
              </div>
            </div>

            {/* Update button */}
            <div className="col-12 col-sm-auto">
              <MainButton
                action="update"
                icon="add"
                label="Update Question Part/Section"
                tone="primary"
                disabled={isEditLocked}
                onClick={() => {
                  setSelectedPartId("");
                  setSelectedSectionId("");
                  setSelectedQuestionIds([]);
                  setIsUpdateDrawerOpen(true);
                }}
              />
            </div>

            {/* Set All Marks */}
            <div className="col-12 col-sm-auto">
              <div className="d-flex align-items-center gap-2 flex-nowrap">
                <label className="setup-set-all-label mb-0" htmlFor="setup-set-all-marks">
                  Set All Marks
                </label>
                <input
                  id="setup-set-all-marks"
                  className="setup-set-all-input"
                  type="number"
                  min="0"
                  value={setAllMarksValue}
                  disabled={isEditLocked}
                  onChange={(e) => setSetAllMarksValue(e.target.value)}
                />
                <MainButton
                  action="save"
                  label="Set Marks"
                  tone="warning"
                  disabled={isEditLocked}
                  onClick={applyMarksToAll}
                />
              </div>
            </div>

            {/* Total Marks */}
            <div className="col-12 col-sm-auto">
              <div className="setup-marks">
                TOTAL MARKS <strong>{totalMarks}</strong>
              </div>
            </div>
          </div>
        </div>

        {isStructureLoading && (
          <div style={{ margin: "16px 0" }}>
            <SectionSpinner text="Adding..." />
          </div>
        )}

        {/* ── Parts / Sections / Questions ── */}
        <DragDropContext onDragEnd={handleDragEnd}>
          <div className="setup-parts-stack">
            {visibleStructure.map((part) => (
              <div className="setup-part-card" key={part.id}>
                {(() => {
                  const maxSections = Number(part.noOfSections);
                  const hasSectionLimit =
                    Number.isFinite(maxSections) && maxSections > 0;
                  const canAddMoreSections =
                    !hasSectionLimit || part.sections.length < maxSections;

                  return (
                    <>
                      <div className="setup-part-card__header">
                        <div>
                          <span className="setup-part-card__eyebrow">Part</span>
                          <h2>{part.title}</h2>
                          <p>{part.instructions}</p>
                        </div>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <MainButton
                            action="delete"
                            icon="delete"
                            label=""
                            tone="danger"
                            title="Delete part"
                            disabled={isEditLocked}
                            onClick={() => deletePart(part.id)}
                          />
                          <MainButton
                            action="edit"
                            icon="edit"
                            label=""
                            tone="neutral"
                            title="Edit part"
                            disabled={isEditLocked}
                            onClick={() => goToPartEdit(part)}
                          />
                        </div>
                      </div>

                      <div className="setup-part-card__body">
                        {part.visibleSections.length ? (
                          part.visibleSections.map((section) => (
                            <SetupSectionCard
                              key={section.id}
                              partId={part.id}
                              section={section}
                              rows={section.visibleQuestions}
                              questionMap={questionMap}
                              onToggleSelected={toggleQuestionSelection}
                              isDisabled={isEditLocked}
                              removingQuestionIds={removingQuestionIds}
                              onMarksChange={(currentPartId, currentSectionId, rowId, value) =>
                                updateQuestionRow(
                                  currentPartId,
                                  currentSectionId,
                                  rowId,
                                  (row) => ({ ...row, marks: value })
                                )
                              }
                              onSubMarksChange={handleSubMarksChange}
                              onToggleAnswer={(currentPartId, currentSectionId, rowId) =>
                                updateQuestionRow(
                                  currentPartId,
                                  currentSectionId,
                                  rowId,
                                  (row) => ({
                                    ...row,
                                    answerRequired: !row.answerRequired,
                                  })
                                )
                              }
                              onRemoveQuestion={removeQuestion}
                              onEditSection={(section) =>
                                goToSectionEdit(part, section)
                              }
                              onDeleteSection={(sectionId) =>
                                deleteSection(part.id, sectionId)
                              }
                              onViewQuestion={goToQuestionView}
                            />
                          ))
                        ) : (
                          <div className="setup-empty-state">
                            No sections added yet. Use the add section control below
                            to create one.
                          </div>
                        )}
                      </div>

                      <div className="setup-add-cta">
                        <span>Add Section</span>
                        <MainButton
                          action="add"
                          icon="add"
                          label=""
                          tone="primary"
                          className="setup-add-cta__button"
                          title={
                            canAddMoreSections
                              ? `Add section to ${part.title}`
                              : `Maximum ${maxSections} sections allowed`
                          }
                          disabled={!canAddMoreSections || isEditLocked || isStructureLoading}
                          onClick={() => addSection(part.id)}
                        />
                        {!canAddMoreSections && (
                          <p style={{ color: "#e74c3c", fontSize: "12px", marginTop: "8px" }}>
                            Maximum {maxSections} sections allowed
                          </p>
                        )}
                      </div>
                    </>
                  );
                })()}
              </div>
            ))}
          </div>

          {/* ── Add Part ── */}
          <div className="setup-add-part">
            <span>Add Part</span>
            <MainButton
              action="add"
              icon="add"
              label=""
              tone="primary"
              className="setup-add-cta__button"
              title={canAddMoreParts ? "Add part" : `Maximum ${maxParts} parts allowed`}
              disabled={!canAddMoreParts || isEditLocked || isStructureLoading}
              onClick={addPart}
            />
            {!canAddMoreParts && maxParts > 0 && (
              <p style={{ color: "#e74c3c", fontSize: "12px", marginTop: "8px" }}>
                Maximum {maxParts} parts allowed
              </p>
            )}
          </div>

          {/* ── Update Part/Section Drawer ── */}
          {isUpdateDrawerOpen && (
            <div
              className="setup-drawer-shell"
              aria-hidden={!isUpdateDrawerOpen}
            >
              <button
                type="button"
                className="setup-drawer-shell__backdrop"
                aria-label="Close update drawer"
                onClick={closeUpdateDrawer}
              />
              <aside
                className="setup-drawer"
                role="dialog"
                aria-modal="true"
                aria-labelledby="setup-drawer-title"
              >
                <div className="setup-drawer__header">
                  <h2 id="setup-drawer-title">Update Question Part/Section</h2>
                  <button
                    type="button"
                    onClick={closeUpdateDrawer}
                    aria-label="Close drawer"
                  >
                    <HiXMark aria-hidden="true" />
                  </button>
                </div>

                <div className="setup-drawer__body">
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="setup-drawer__field">
                        <span>Select Part</span>
                        <select
                          value={selectedPartId}
                          disabled={isEditLocked}
                          onChange={(e) => {
                            setSelectedPartId(e.target.value);
                            setSelectedSectionId("");
                          }}
                        >
                          <option value="">Select Part</option>
                          {partOptions.map((part) => (
                            <option key={part.id} value={part.id}>
                              {part.title}
                            </option>
                          ))}
                        </select>
                      </label>
                    </div>

                    <div className="col-12">
                      <label className="setup-drawer__field">
                        <span>Select Section</span>
                        <select
                          value={selectedSectionId}
                          onChange={(e) => setSelectedSectionId(e.target.value)}
                          disabled={
                            isEditLocked || !selectedPartId || !selectedPart?.sections.length
                          }
                        >
                          <option value="">Select Section</option>
                          {(selectedPart?.sections || []).map((section) => (
                            <option key={section.id} value={section.id}>
                              {section.title}
                            </option>
                          ))}
                        </select>
                      </label>
                      {!selectedPartId ? (
                        <p className="setup-drawer__hint">
                          Please select a part to load sections.
                        </p>
                      ) : selectedPart && !selectedPart.sections.length ? (
                        <p className="setup-drawer__hint">
                          This part has no sections yet. Add a section first.
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="setup-drawer__table-wrap">
                    <h3>Please select the questions to update part/section</h3>
                    <div className="table-responsive">
                      <table className="setup-drawer-table">
                        <thead>
                          <tr>
                            <th>
                              <label className="setup-drawer-table__checkall">
                                <input
                                  type="checkbox"
                                  checked={
                                    drawerRows.length > 0 &&
                                    selectedQuestionIds.length ===
                                    drawerRows.length
                                  }
                                  disabled={isEditLocked}
                                  onChange={toggleSelectAllDrawerQuestions}
                                  aria-label="Select all questions"
                                />
                                <span>Select All</span>
                              </label>
                            </th>
                            <th>Question Code</th>
                            <th>Question Title</th>
                            <th>Question Type</th>
                            <th>Assigned Part</th>
                            <th>Assigned Section</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <Droppable droppableId="drawer">
                          {(provided) => (
                            <tbody
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                            >
                              {drawerRows.map((question, index) => (
                                <Draggable
                                  draggableId={String(question.id)}
                                  index={index}
                                  key={question.id}
                                >
                                  {(dragProvided) => (
                                    <tr
                                      ref={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                      {...dragProvided.dragHandleProps}
                                    >
                                      <td>
                                        <input
                                          type="checkbox"
                                          checked={selectedQuestionIds.includes(
                                            question.id
                                          )}
                                          disabled={isEditLocked}
                                          onChange={() =>
                                            toggleDrawerQuestion(question.id)
                                          }
                                          aria-label={`Select ${question.name}`}
                                        />
                                      </td>
                                      <td>{question.code}</td>
                                      <td>{question.name}</td>
                                      <td>{question.type}</td>
                                      <td>{question.assignedPart}</td>
                                      <td>{question.assignedSection}</td>
                                      <td>
                                        <div className="setup-question-row__actions">
                                          <ViewButton
                                            label="View"
                                            title="View question"
                                            onClick={() => goToQuestionView(question)}
                                          />
                                          <DeleteButton
                                            label="Remove"
                                            title="Remove question from assessment"
                                            aria-label={`Remove ${question.name} from assessment`}
                                            disabled={isEditLocked}
                                            loading={removingQuestionIds.includes(
                                              String(question.questionId)
                                            )}
                                            onClick={() =>
                                              removeQuestionFromAssessment(
                                                question.questionId
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </tbody>
                          )}
                        </Droppable>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="setup-drawer__footer">
                  <MainButton
                    action="save"
                    label="Update Part/Section"
                    tone="neutral"
                    disabled={
                      isEditLocked ||
                      !selectedPartId ||
                      !selectedSectionId ||
                      !selectedQuestionIds.length
                    }
                    onClick={applyDrawerAssignment}
                  />
                  <MainButton
                    action="cancel"
                    label="Cancel"
                    tone="neutral"
                    onClick={closeUpdateDrawer}
                  />
                </div>
              </aside>
            </div>
          )}
        </DragDropContext>
      </section>
    </ContentWrapper>
  );
}
